module.exports = __webpack_public_path__ + "static/media/reward.17b2d637.svg";